import { formatCompactDuration } from '../../utils/compactDuration';
import { tierTextClass, type LatenessTier } from '../work-queue/timeThresholds';

interface TimeCellProps {
    iso: string | null;
    tier: LatenessTier | null;
    /** Format the absolute line in UTC - for date-only milestone values. */
    utc?: boolean;
    /** Clock to measure against; callers ticking with useNow pass theirs. */
    now?: number;
}

// Compact age on top, escalated by `tier`; the absolute date below stays muted.
export function TimeCell({ iso, tier, utc = false, now }: TimeCellProps) {
    const date = iso ? new Date(iso) : null;
    if (!date || Number.isNaN(date.getTime())) {
        return <span className="text-xs text-gray-400">-</span>;
    }
    const relative = formatCompactDuration(iso, now ?? Date.now());
    const shortDate = date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: '2-digit',
        timeZone: utc ? 'UTC' : undefined
    });
    return (
        <div className="leading-tight">
            <div className={`text-xs whitespace-nowrap ${tierTextClass(tier)}`}>{relative}</div>
            <div className="text-[10px] text-gray-400 whitespace-nowrap">{shortDate}</div>
        </div>
    );
}
